import React from 'react';

import Chip from '@mui/material/Chip';

/**
 * 優先度コード（type_code）ごとの固定色。
 * 表示名（高/中/低）は API9001（master_type: priority）で解決するため label で受け取る。
 * 未知コードはデフォルト色でフォールバックする。
 */
const PriorityColor: Record<string, string> = {
  HIGH: '#d32f2f',
  MIDDLE: '#ed6c02',
  LOW: '#0288d1',
};

type Props = {
  /** 優先度コード（HIGH/MIDDLE/LOW 等・master_type.type_code） */
  code: string;
  /** 表示名（API9001 で解決。未指定時は code をそのまま表示） */
  label?: string;
  size?: 'small' | 'medium';
};

/** 優先度を表示するチップ（色はコード固定・表示名は master_type 解決） */
const TicketPriorityChip: React.FC<Props> = ({ code, label, size = 'small' }) => {
  const color = PriorityColor[code] ?? '#757575';
  return (
    <Chip
      label={label ?? code}
      size={size}
      variant="outlined"
      sx={{
        color,
        borderColor: color,
        fontWeight: 600,
        ...(size === 'small' && { height: 20, fontSize: '0.7rem' }),
      }}
    />
  );
};

export default TicketPriorityChip;
